import { render, staticRenderFns } from "./LtkListVirtual.vue?vue&type=template&id=fd7a47b8&scoped=true"
import script from "./LtkListVirtual.vue?vue&type=script&setup=true&lang=ts"
export * from "./LtkListVirtual.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LtkListVirtual.vue?vue&type=style&index=0&id=fd7a47b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd7a47b8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LtkFeedItem: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/Ltk/LtkFeedItem.vue').default,CContainer: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CGrid/CContainer.vue').default})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Resize from 'vuetify/lib/directives/resize'
import Scroll from 'vuetify/lib/directives/scroll'
installDirectives(component, {Resize,Scroll})
